import StatsRule from "../../../common/stats-rule";
import { getFieldDirectionMultiplier } from "../../utils/context-utils";
import FootballStatsCategory from "../../stats/football-stats-category";
import FootballState from "../../state/football-state";

export default class CflTeamLossStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { homeTeamHasPossession } = gameContext;
        const endSpot = play.getEndFieldPosition();
        const { fieldPosition: lineOfScrimmage } = play.contextSnapshot;
        const isLastFragment =
            play.fragments[play.fragments.length - 1]?.id === fragment.id;

        const isKick = [
            FootballState.FieldGoalBlocked,
            FootballState.FieldGoalFumble,
            FootballState.PuntBlocked
        ].some((state) => play.historyContains(state));

        const penaltyAccepted = play.getPreceedingFragment(fragment, [
            FootballState.PlayPenaltyPenaltyAccepted,
            FootballState.PenaltyAccepted
        ]);

        const startSpot = penaltyAccepted?.enforcementSpot || lineOfScrimmage;

        const isSack = play.historyContains(FootballState.PassSacked);
        const isKneel = play.historyContains(FootballState.KneelDown);
        const isElligibleFumbledSnap =
            play.historyContains(FootballState.FumbledSnapRecovered) &&
            ![
                FootballState.Rush,
                FootballState.Punt,
                FootballState.FieldGoal,
                FootballState.Pass
            ].some((s) => s === play.historyContains(s));

        return (
            isLastFragment &&
            (isKick ||
                !!penaltyAccepted ||
                isSack ||
                isKneel ||
                isElligibleFumbledSnap) &&
            (homeTeamHasPossession
                ? startSpot > endSpot
                : startSpot < endSpot) &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { homeTeamId, awayTeamId, homeTeamHasPossession } = gameContext;
        const penaltyAccepted = play.getPreceedingFragment(fragment, [
            FootballState.PlayPenaltyPenaltyAccepted,
            FootballState.PenaltyAccepted
        ]);

        return this.addStats({
            gameId: play.gameId,
            playId: play.id,
            period: gameContext.currentPeriod,
            teamId: homeTeamHasPossession ? homeTeamId : awayTeamId,
            playerId: null,
            driveId: gameContext.currentDriveId,
            fragmentId: fragment.id,
            category: FootballStatsCategory.TEAM_LOSS,
            values: {
                completed: 1,
                yards: Math.abs(
                    play.getYardsGained(
                        getFieldDirectionMultiplier(play.contextSnapshot),
                        penaltyAccepted?.enforcementSpot
                    )
                )
            }
        });
    }
}
